import $ from 'jquery';

export const init = () => {

	$(document)
		.on('click', '.js-toggle-class', function(e) {
			e.preventDefault();

			var $this = $(this);

			$this.toggleClass('is-open');
			$( $this.data('target') ).toggleClass( $this.data('class') );

		})
		.on('click', '.js-footer__link', function(e) {
			e.preventDefault();

			var $this = $(this),
				$footer = $this.closest('.js-footer'),
				$parent = $this.closest('.js-footer__item'),
				$content = $parent.children('.js-footer__content');

			if ( $parent.hasClass('is-open') ) {
				$content.slideUp(function() {
					$parent.removeClass('is-open');
				});
			}
			else {
				$content.slideDown(function() {
					$parent.addClass('is-open');
				});
			}

			// close other opened items
			$footer.find('.js-footer__item').not($parent).find('.js-footer__content').slideUp(function() {
				$(this).closest('.js-footer__item').not($parent).removeClass('is-open');
			});

		})
		.on('change', '.js-toggle-checked', function(e) {
			e.preventDefault();

			var $this = $(this);

			var $name =  $this.attr('name');

			$('input[name="'+$name+'"]').closest('li').filter('.is-checked').removeClass('is-checked');
			$this.closest('li').toggleClass('is-checked');
			$( $this.data('target') ).closest('li').toggleClass( $this.data('class') );

		});

	//$('.js-toggle-checked').trigger('change');
};
